import { newTeamAssistV2Answer, reduceTeamAssistV2Event } from 'actions/team_assist_v2/lib/team_assist_v2_answer';
import TeamAssistV2Turn from 'models/team_assist_v2_turn';

// Deltas arrive a few tokens at a time; writing each one rebuilds the whole
// answer in the store and re-renders the panel, so they're batched this long.
export const WRITE_INTERVAL_MS = 50;

/**
 * A turn being streamed into the customer's `teamAssistsV2` store. It stops
 * being `live` at its `done` or `error` event, or when it fails. Once `signal`
 * aborts, it never writes again.
 */
export default class StreamingTeamAssistV2Turn {
  constructor({ store, signal, id, question, displayedMessage, conversationId }) {
    this.store = store;
    this.signal = signal;
    this.attrs = { id, question, displayedMessage, conversationId };
    this.answer = newTeamAssistV2Answer();
    this.live = true;
    this.writeTimer = null;
    this._write();
  }

  get id() {
    return this.attrs.id;
  }

  apply(event) {
    if (this.signal.aborted || !this.live) {
      return;
    }
    this.answer = reduceTeamAssistV2Event(this.answer, event);
    if (event.type !== 'done' && event.type !== 'error') {
      this._scheduleWrite();
      return;
    }
    this.live = false;
    this._dropLoadedCopy(this.answer.questionId);
    this._write();
  }

  fail(code) {
    this.apply({ type: 'error', code });
  }

  _scheduleWrite() {
    if (this.writeTimer === null) {
      this.writeTimer = setTimeout(() => this._write(), WRITE_INTERVAL_MS);
    }
  }

  _write() {
    clearTimeout(this.writeTimer);
    this.writeTimer = null;
    if (this.signal.aborted) {
      return;
    }
    this.store.addOrReplace(TeamAssistV2Turn.create({ ...this.attrs, answer: this.answer, live: this.live }));
  }

  // A session loaded while this turn streamed can already hold its answered
  // question, under glados's id for it rather than this turn's.
  _dropLoadedCopy(questionId) {
    if (!questionId || !this.store.has({ id: questionId })) {
      return;
    }
    this.store.set(this.store.findAll().filter(turn => turn.id !== questionId));
  }
}
